export default {"src":"/_next/static/media/immigration_translators1.5eb08aee.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};